<template>
    <div class='horizontal-bar'>
        <div class='bar'>
            <div class="container">
                <div class="item" v-for="(itemView) in itemViews"
                     :style="{width: itemView.widthPercent + '%', background: itemView.color}"/>
            </div>
        </div>
        <ul>
            <li v-for="(item) in items">
                <span class="title">{{ item.label }}:</span>
                <span class="value" :style="colorize?{color: item.color}:{}">{{
                        item.value
                    }}{{ unit ? ' ' + unit : '' }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'horizontal-bar',
    props: ['items', 'colorize', 'unit'],
    computed: {
        itemViews: function () {
            const total = this.items.map(i => i.value).reduce((c, p) => c + p);

            if (total === 0) {
                return [{
                    widthPercent: 100,
                    color: 'rgba(0, 0, 0, 0.1)'
                }]
            } else {
                let curr = 0;
                return this.items
                    .map((item) => {
                        const val = item.value + curr;
                        curr += item.value;
                        return {
                            widthPercent: val / total * 100,
                            color: item.color
                        }
                    })
                    .reverse();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/part/item/horizontal_bar.vue